import cx from 'classnames';
import type { FunctionComponent } from 'react';

type Props = {
  hasCheckbox?: boolean;
  hasEvenPadding?: boolean;
};

/**
 * ListHeader is rendered at the top of the <List>,
 * generally the first child. It often contains a HeaderTitle
 * with a count, but can also contain links or buttons.
 */
const ListHeader: FunctionComponent<Props> = ({ children, hasCheckbox, hasEvenPadding }) => (
  <header className={cx('fossa-list__header', {
    'fossa-list__header--has-checkbox': hasCheckbox,
    'fossa-list__header--even-padding': hasEvenPadding,
  })}>
    {children}
  </header>
);

export default ListHeader;
